/**
 * Minimalerei Collection Page — Filter & Sort Mechanics
 *
 * Phase X.1: Sticky filter bar detection
 * Phase X.2 (this): Drawer, Sort-Dropdown, scroll lock, filter-group toggle
 *
 * Note: Filter selection itself uses native Liquid links + form submit.
 * JS only handles UI state (drawer open/close, sort dropdown, sticky detection).
 * No-JS-fallback: Pills work as <a> tags, sort options work as <a> tags,
 * only "Mehr Filter"-drawer is JS-only.
 */

(function () {
  'use strict';

  // ============================================
  // STICKY FILTER BAR DETECTION (Phase X.1)
  // ============================================

  const filterBar = document.querySelector('[data-mp-filter-bar]');

  if (filterBar) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText =
      'position: absolute; top: 0; height: 1px; width: 1px; pointer-events: none;';
    filterBar.parentNode.insertBefore(sentinel, filterBar);

    const stickyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            filterBar.classList.remove('is-stuck');
          } else {
            filterBar.classList.add('is-stuck');
          }
        });
      },
      { threshold: 0 }
    );

    stickyObserver.observe(sentinel);
  }

  // ============================================
  // FILTER DRAWER (Phase X.2)
  // ============================================

  const drawer = document.querySelector('[data-mp-drawer]');
  const drawerOpenBtns = document.querySelectorAll('[data-mp-drawer-open]');
  const drawerCloseBtns = document.querySelectorAll('[data-mp-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    // requestAnimationFrame: lass den Browser den hidden-State commit-en,
    // BEVOR die is-open-Klasse die Transition triggert. Sonst ist der
    // Start-State (translateX(100%)) nicht im Layout und der Slide-In
    // wäre instant statt animiert.
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    // Body-Scroll lock + body-Klasse setzen — CSS-Regeln verstecken
    // damit den Smile.io-Member-Pillen-Launcher solange der Drawer offen ist.
    document.body.style.overflow = 'hidden';
    document.body.classList.add('mp-drawer-open');
    const firstFocusable = drawer.querySelector(
      'button, [href], input, select, textarea'
    );
    if (firstFocusable) {
      setTimeout(() => firstFocusable.focus(), 100);
    }
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('mp-drawer-open');
    // hidden erst NACH der Slide-Out-Transition (350ms) setzen, sonst
    // springt der Drawer einfach weg ohne Animation.
    setTimeout(() => {
      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
      }
    }, 350);
  }

  if (drawer) {
    drawerOpenBtns.forEach((btn) => {
      btn.addEventListener('click', openDrawer);
    });

    drawerCloseBtns.forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  // ============================================
  // FILTER GROUP COLLAPSE (im Drawer)
  // ============================================

  const filterToggles = document.querySelectorAll('[data-mp-filter-toggle]');

  filterToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  // ============================================
  // SORT DROPDOWN (Desktop in Major-Row + Mobile in Action-Bar)
  // ============================================
  // Beide Sort-Instanzen werden parallel angesteuert. Jeder Toggle ist
  // mit seinem Menu innerhalb des gleichen [data-mp-sort]-Wrappers
  // gekoppelt — so kann ein Toggle nie das falsche Menu auslösen.

  const sortWraps = document.querySelectorAll('[data-mp-sort]');

  function closeSortMenu(wrap) {
    const menu = wrap.querySelector('[data-mp-sort-menu]');
    const toggle = wrap.querySelector('[data-mp-sort-toggle]');
    if (!menu || !toggle) return;
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function openSortMenu(wrap) {
    const menu = wrap.querySelector('[data-mp-sort-menu]');
    const toggle = wrap.querySelector('[data-mp-sort-toggle]');
    if (!menu || !toggle) return;
    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeAllSortMenus() {
    sortWraps.forEach(closeSortMenu);
  }

  sortWraps.forEach((wrap) => {
    const toggle = wrap.querySelector('[data-mp-sort-toggle]');
    const menu = wrap.querySelector('[data-mp-sort-menu]');

    if (!toggle || !menu) return;

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = !menu.hidden;
      // Erst alle Sort-Menus schließen — verhindert dass beim
      // Resize-Übergang Mobile/Desktop beide gleichzeitig offen sind.
      closeAllSortMenus();
      if (!isOpen) {
        openSortMenu(wrap);
      }
    });
  });

  // Click außerhalb aller Sort-Wraps schließt alle Menüs.
  document.addEventListener('click', (e) => {
    let isInsideAnySort = false;
    sortWraps.forEach((wrap) => {
      if (wrap.contains(e.target)) {
        isInsideAnySort = true;
      }
    });
    if (!isInsideAnySort) {
      closeAllSortMenus();
    }
  });

  // ESC schließt alle Sort-Menus.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllSortMenus();
    }
  });
})();
